import React, { useEffect, useState } from 'react';
export function StickyShopButton() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const heading = document.getElementById('product-reveal');
      const finalCta = document.getElementById('final-cta');
      if (heading) {
        const headingRect = heading.getBoundingClientRect();
        setIsVisible(headingRect.top < 0);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll(); // Check initial state
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed bottom-6 left-1/2 -translate-x-1/2 z-[900] transition-all duration-500 ease-in-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'}`} data-id="element-211">
      <a href="https://vitalenehealth.com" target="_blank" rel="noopener noreferrer" className="block outline-none focus-visible:ring-4 focus-visible:ring-brand-teal/50 rounded-full" data-id="element-212">
        <button className="bg-brand-orange/85 backdrop-blur-md text-white font-semibold rounded-full px-8 py-3.5 shadow-[0_8px_32px_rgba(230,126,34,0.35)] border border-white/30 hover:bg-brand-orange/95 transition-all duration-300 hover:scale-[1.05] active:scale-[0.98] flex items-center gap-2 text-[16px] md:text-[17px] tracking-[0.5px]" aria-label="Shop Now" data-id="element-213">
          Shop Now
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-214">
            <path d="M5 12h14M12 5l7 7-7 7" data-id="element-215" />
          </svg>
        </button>
      </a>
    </div>;
}